module.exports = __webpack_public_path__ + "static/media/professional-teaching-ad2.0fcc3e4d.png";